import type { IntegrationDescriptor, IntegrationToggleErrorCode } from './types';

/**
 * #839 — does this row carry an operator switch that DOES something here?
 * `not_toggleable` means the declaring app decides from its boot-time env
 * alone, so the row keeps its pre-#839 shape (no switch, no change in grouping).
 */
export function hasLiveSwitch(descriptor: Pick<IntegrationDescriptor, 'toggle'>): boolean {
  const toggle = descriptor.toggle;
  return toggle !== undefined && toggle.reason !== 'not_toggleable';
}

/** Upper bound the BFF enforces on the reason (`INTEGRATION_TOGGLE_REASON_MAX`). */
export const TOGGLE_REASON_MAX = 280;

/** A refused or failed #839 toggle write, with the BFF's reason code. */
export class IntegrationToggleError extends Error {
  constructor(
    readonly code: IntegrationToggleErrorCode,
    readonly status: number,
  ) {
    super(`integration toggle refused: ${code} (HTTP ${status})`);
    this.name = 'IntegrationToggleError';
  }
}

